export default __webpack_public_path__ + "static/media/PHÂN HỆ BẢNG ĐIỀU KHIỂN.0595401c.pdf";